"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidedLine = void 0;
const react_1 = __importDefault(require("react"));
const NumericFormatTwoDecimals_1 = require("../../numeric-format/NumericFormatTwoDecimals");
const ReverseVoidedAction_1 = require("../actions/ReverseVoidedAction");
const VoidedLine = (props) => {
    return (react_1.default.createElement("tr", { className: "invoice-void" },
        react_1.default.createElement("td", null, "Rechnung storniert"),
        react_1.default.createElement("td", null,
            react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: -props.voidedAmount })),
        react_1.default.createElement("td", null, props.editable && (react_1.default.createElement(ReverseVoidedAction_1.ReverseVoidedAction, { booking: props.booking, onDelete: props.onReverseVoided })))));
};
exports.VoidedLine = VoidedLine;
